import React, { useState, useEffect } from 'react';
import Layout from '../layout/Layout';
import { toast } from 'react-toastify';
import { useUser } from "../context/UserContext";
import axios from 'axios';
import config from '../config';
import utils from "../utils/Utils";
import Form from '../components/Form';
import PageTitle from '../components/PageTitle';
import FormField from '../components/FormField';
import PasswordHints from '../components/PasswordHints';
import ShowErrors from '../components/ShowErrors';
import ButtonSubmit from '../components/ButtonSubmit';

const Profile = () => {
    const { user, setUser, authService } = useUser();
    const [profile, setProfile] = useState();
    const [loading, setLoading] = useState(false);
    const [hints, setHints] = useState([]);
    const [errors, setErrors] = useState([]);

    // useEffect(() => {
    //     const fetchProfile = async () => {
    //         // const response = await axios.get(`${config.apiBaseUrl}/profile`, {
    //         const response = await authService.get(`/profile`, {
    //             params: {
    //                 email: user.email
    //             }
    //         });
    //         // console.log(response.data);
    //         setUser(response.data);
    //     };
    //     // console.log("Refresh user profile before page mounts");
    //     fetchProfile();

    //     return () => {
    //         // console.log("Refresh user profile before page unmounts");
    //         // fetchProfile();
    //     };
    // }, []);

    // useEffect(() => {
    //     const refresh = async () => {
    //         try {
    //             const response = await axios.get(`${config.apiBaseUrl}/auth/refresh`, {
    //                 withCredentials: true,  // must include this to allow fastAPI to create cookies
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     // 'Access-Control-Allow-Origin': config.apiBaseUrl,
    //                 },
    //             });
    //             console.log(response);
    //         } catch {
    //             console.log("Failed to refresh tokens");
    //         }
    //     };
    //     refresh();
    // }, []);

    useEffect(() => {
        const loadProfile = () => {
            // console.log(user);
            setProfile(user);
        };
        loadProfile();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;

        // Transform the name field to title case
        if (name === 'name') {
            const titleCaseValue = utils.toTitleCase(value);
            setProfile((prevUser) => ({
                ...prevUser,
                [name]: titleCaseValue,
            }));
        } else if (name === 'email') {
            setErrors([]);
            setProfile((prevUser) => ({
                ...prevUser,
                [name]: value.toLowerCase(),
            }));
        } else {
            setProfile((prevUser) => ({
                ...prevUser,
                [name]: value,
            }));
        }

        // if (name === 'password') {
        //     setHints([]);
        //     if (value.length > 0) {
        //         const hints = utils.validatePassword(value);
        //         if (hints.length > 0) {
        //             setHints(hints);
        //         }
        //     }
        // }
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;

        setProfile((prevUser) => ({
            ...prevUser,
            [name]: value.trim(),
        }));

        if (name === 'email') {
            setErrors([]);
            const errors = utils.validateEmail(user.email);
            if (errors.length > 0) {
                setErrors(errors);
                return;
            }
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // console.log(profile.password);
        setHints([]);
        const hints = utils.validatePassword(profile.password);
        if (hints.length > 0) {
            setHints(hints);
            return;
        }

        setLoading(true);
        try {
            // console.log(profile);
            // const response = await axios.put(`${config.apiBaseUrl}/profile/${profile.email}`, profile);
            const response = await authService.put(`/profile/${profile.email}`, profile);
            // console.log(response);
            // console.log(response.data);
            if (response.status === 200) {
                setUser(profile);
                // toast.success(response.data.message ?? "Success");
                toast.success('User profile updated successfully');
            } else {
                toast.error('Failed to update user profile');
            }
            
        } catch (error) {
            // console.log(error);
            // toast.error(error.message ?? "Error");
            toast.error('Failed to update user profile');
        } finally {
            setLoading(false);
        };
    };

    const handleVerify = async (e) => {
        e.preventDefault();

        try {
            const response = await axios.post(`${config.apiBaseUrl}/auth/resend-verification/${user.email}`, {
                withCredentials: true,  // must include this to allow fastAPI to create cookies
            });
            console.log(response);
            console.log(response.data);
            if (response.status === 200) {
                toast.success('Verification email sent, please click link in email to verify');
            } else {
                toast.error('Failed to send verification email');
            }

        } catch (error) {
            toast.error('Failed to send verification email')
        }
    }

    return (
        <Layout>
            <Form handleSubmit={handleSubmit}>
                <PageTitle pageTitle={"User Profile"} />

                <FormField
                    label={"Name"}
                    name={"name"}
                    type={"text"}
                    value={profile?.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required={true}
                    autoFocus={true}
                />

                <div className='relative'>
                    <FormField
                        label={"Email"}
                        name={"email"}
                        type={"email"}
                        value={profile?.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        readOnly={true}
                    />
                    <div className='absolute inset-y-12 right-0 pr-0 flex items-center text-sm leading-5 text-orange-300'>
                        {user.is_verified ?
                            <div className='pr-2'>
                                Verified
                            </div>
                        :   <button className='bg-orange-400 text-white py-2 px-4 rounded-lg duration-300 hover:scale-103'
                                onClick={handleVerify}
                            >
                                Resend Verify
                            </button>
                        }
                    </div>
                </div>

                <FormField
                    label={"Password"}
                    name={"password"}
                    type={"password"}
                    value={profile?.password}
                    autoComplete="current-password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                />
                <PasswordHints hints={hints} />

                <FormField
                    label={"Phone"}
                    name={"phone"}
                    type={"text"}
                    value={profile?.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />

                <FormField
                    label={"Wallet Address"}
                    name={"wallet_address"}
                    type={"text"}
                    value={profile?.wallet_address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                />

                <ShowErrors errors={errors} />
                
                <ButtonSubmit 
                    loading={loading} 
                    labeling={'Saving ...'} 
                    label={'Save'} 
                    // disabled={loading || hints.length > 0 || errors.length > 0}
                />
            </Form>
        </Layout>
    );
};

export default Profile;

